import React from "react";
import WheelComponent from "../WheelComponent";
import { DEFAULT_WHEEL_CHART_DATA } from "./defaultWheelChartData";

// A fully-transparent 1x1 gif — same trick PickerWheelThumb.jsx uses. Keeps
// WheelComponent's own center portrait invisible so a caller's own overlay
// (a logo image, or nothing at all) is the only thing drawn at the center;
// without this every default-wheel surface would paint a SECOND iYuga logo
// underneath whatever the caller already layers on top.
const CLEAR_CENTER =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

const noop = () => {};

// gordon-0920-default-wheel-and-create-wheel-hero-geometry-must-match-
// standard-wheel-REPEAT-COMPLAINT — THE one non-data Wheel mark. Renders
// through WheelComponent/createPie.js (the same engine every real data Wheel
// uses — createPie.js:596-629 resize(), createPie.js:346 arcPaddingRadius,
// D3Wheels/index.scss:149-151 `.arc { stroke: white }`) fed
// DEFAULT_WHEEL_CHART_DATA instead of real API segments, with the SAME
// full-bleed recipe (arcThickness:0, margin:0) every real wheel-art thumbnail
// already uses (CollectionCard.jsx wheelArtProps). Because it is literally
// the same renderer + the same recipe, divider width, outer hairline, white
// rim and ring thickness are byte-identical to a real Wheel at any size —
// there is no second geometry to keep in sync.
export default function DefaultWheelRing() {
  return (
    <WheelComponent
      userData={{ id: "default-wheel", url: CLEAR_CENTER }}
      chartData={DEFAULT_WHEEL_CHART_DATA}
      setChartData={noop}
      maxSelectedArcs={0}
      arcThickness={0}
      margin={0}
      gifHoverPreview
      enableSegmentHoverMotion={false}
      width="100%"
      height="100%"
      containerDivStyle={{ width: "100%", height: "100%" }}
      // resize:false (not true, unlike a real wheel-art thumbnail) — this
      // ring's data never changes, and every caller's own CSS already
      // stretches the wheel's <svg> to its container's 100% width/height
      // (CollectionCoverWheelArt's "& svg" rule; TopCircle is a fixed-px
      // circle) — a uniform scale of a square SVG onto a square box, which
      // preserves every geometry ratio exactly. Enabling live resize would
      // instead depend on WheelComponent's ResizeObserver firing an initial
      // callback to draw the arcs at all — true in every real browser (the
      // spec guarantees an initial observation), but not in this repo's
      // jsdom test environment, whose global ResizeObserver mock never fires
      // (see setupTests.js). resize:false instead makes
      // WHEEL_SEGMENTS_FIRST_PAINT_ENABLED (default ON) draw the arcs
      // synchronously at construction — matching the OLD <BrandWheel>'s
      // always-immediate, layout-independent render exactly, in production
      // and in tests alike.
      resize={false}
      config={{ showTooltips: false }}
    />
  );
}
